<template>
  <v-toolbar-items>
    <v-menu offset-y>
      <template v-slot:activator="{ on }">
        <v-btn text v-on="on" class="anchor--text langSwitcher">
          <v-icon left>mdi-account-star</v-icon>
          <v-icon>mdi-chevron-down</v-icon>
        </v-btn>
      </template>
      <v-list>
        <v-container ma-1>
          <h4>{{ $t("administrator") }}</h4>
        </v-container>
        <v-divider></v-divider>
        <v-list-item
          v-for="(tab, idx) in avatarOptions"
          :key="idx"
          @click="optionSelected(tab.name)"
        >
          <v-icon left>{{ tab.icon }}</v-icon>
          <span left>{{ $t(tab.name) }}</span>
        </v-list-item>
      </v-list>
    </v-menu>
  </v-toolbar-items>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  name: "UserAvatar",
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["user", "avatarOptions"]),
  },
  methods: {
    ...mapActions(["logout"]),
    optionSelected(option) {
      switch (option) {
        case "fileManager":
          this.$router.push({name: "fileManager"});
          break;
        case "logout":
          this.logout();
          if (this.$router.currentRoute.name !== "home") {
            this.$router.push("/");
          }
          break;
      }
    },
  },
};
</script>
